<script setup lang="ts">
import ComingSoonView from './views/ComingSoonView.vue';
</script>

<template>
  <div class="app-root dark min-h-screen bg-surface-950 font-sans text-text-secondary">
    <ComingSoonView />
  </div>
</template>
